// Fee & Obligation PR-5 — query-key factory for the standing worksheet's
// forward-projection + Income Pools forward-overlay reads. Array-literal query
// keys live ONLY in *Keys.ts files (stale-after-save convention).

export const forwardProjectionKeys = {
  projection: (loanId: string, horizonMonths: number) =>
    ["portfolio-admin", "loan", loanId, "forward-projection", horizonMonths] as const,
  incomePoolsForward: (loanId: string, horizonMonths: number) =>
    ["portfolio-admin", "loan", loanId, "income-pools-forward", horizonMonths] as const,
  // Prefixes for invalidation — a fee/obligation mutation that changes what the
  // projection reads (approve creates an obligation, waive drops one, a new
  // approved fee bills next statement) invalidates every horizon variant.
  projectionPrefix: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "forward-projection"] as const,
  incomePoolsForwardPrefix: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "income-pools-forward"] as const,
};
